import { Role } from '@/types/domain/user';

export type AuditEventType =
  | 'LOGIN_SUCCESS'
  | 'LOGIN_FAILED'
  | 'LOGOUT'
  | 'SESSION_EXPIRED'
  | 'PASSWORD_RESET_REQUESTED'
  | 'PASSWORD_RESET_COMPLETED'
  | 'PASSWORD_RESET_TRIGGERED'
  | 'ACCOUNT_LOCKED'
  | 'ACCOUNT_UNLOCKED'
  | 'MFA_CHALLENGE'
  | 'MFA_SUCCESS'
  | 'MFA_FAILURE'
  | 'ROLE_CHANGED'
  | 'UNAUTHORIZED_ACCESS_ATTEMPT'
  | 'USER_CREATED'
  | 'USER_UPDATED'
  | 'USER_ACTIVATED'
  | 'USER_DEACTIVATED'
  | 'USER_BLOCKED'
  | 'USER_UNBLOCKED'
  | 'INVITATION_SENT'
  | 'INVITATION_RESENT';

export interface AuditEvent {
  id: string;
  eventType: AuditEventType;
  actorId?: string;
  actorEmail?: string;
  actorRole?: Role;
  timestamp: string;
  sourceIp?: string;
  details?: Record<string, unknown>;
}

class AuditService {
  private logs: AuditEvent[] = [];

  log(eventType: AuditEventType, actor?: { id?: string; email?: string; role?: Role }, details?: Record<string, unknown>) {
    const event: AuditEvent = {
      id: `AUD-${Date.now()}-${Math.floor(Math.random() * 1000)}`,
      eventType,
      actorId: actor?.id || 'ANONYMOUS',
      actorEmail: actor?.email || 'N/A',
      actorRole: actor?.role,
      timestamp: new Date().toISOString(),
      sourceIp: '127.0.0.1 (Client)',
      details,
    };
    this.logs.unshift(event);
  }

  getLogs(): AuditEvent[] {
    return [...this.logs];
  }
}

export const auditService = new AuditService();
